var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ff-alocacao-pizzas az-card-bordered rounded-sm" },
    [
      _c(
        "p",
        {
          staticClass: "az-ds-label mb-2",
          attrs: { "data-teste": "simulacao-alocacao-titulo" }
        },
        [_vm._v(" O que muda na sua carteira ")]
      ),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-wrap justify-center align-center az-gap ff-alocacao-pizzas__grafs"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column align-center ff-alocacao-pizzas__graf"
            },
            [
              _c("p", { staticClass: "az-ds-aux mb-1" }, [_vm._v("Hoje")]),
              _c("pie-chart", {
                attrs: {
                  "data-teste": "simulacao-alocacao-pizza-hoje",
                  "chart-data": _vm.chartDataHoje,
                  options: _vm.chartOptionsHoje,
                  width: 140,
                  height: 140
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column align-center ff-alocacao-pizzas__graf"
            },
            [
              _c("p", { staticClass: "az-ds-aux mb-1" }, [_vm._v("Depois")]),
              _c("pie-chart", {
                attrs: {
                  "data-teste": "simulacao-alocacao-pizza-depois",
                  "chart-data": _vm.chartDataDepois,
                  options: _vm.chartOptionsDepois,
                  width: 140,
                  height: 140
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "ul",
        { staticClass: "ff-alocacao-pizzas__legenda mt-3" },
        _vm._l(_vm.linhasFormatadas, function(linha) {
          return _c(
            "li",
            {
              key: linha.classe,
              staticClass:
                "d-flex align-center az-gap-xsmall az-ds-aux ff-alocacao-pizzas__item",
              attrs: { "data-teste": "simulacao-alocacao-linha" }
            },
            [
              _c("span", {
                staticClass: "ff-alocacao-pizzas__cor",
                style: { backgroundColor: linha.cor }
              }),
              _c("span", { staticClass: "ff-alocacao-pizzas__nome" }, [
                _vm._v(_vm._s(linha.nome))
              ]),
              _c("span", [_vm._v(_vm._s(linha.variacaoLabel))])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }